import Button from '../Button/Button';
import React, { PropsWithChildren } from 'react';
import { BasicModalBelowWrapper } from './BasicModalBelowWrapper';

import { View } from 'react-native';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';





interface ModalBelowProps extends PropsWithChildren {
    isVisible: boolean;
    onDismiss: () => void;
    labelButton: string;
  }


export const BasicModalBelowWithButton = ({ isVisible, onDismiss, labelButton, children}: ModalBelowProps) => {
  const {width, height } = useAvailableDimensions();
  const MARGIN_HORIZONTAL=20;
  const WIDTH = Math.min(600, width-2*MARGIN_HORIZONTAL);




  return (
    <BasicModalBelowWrapper isVisible={isVisible} onDismiss={onDismiss}>
      <View style={{
        rowGap:30,
        maxHeight: height * 0.75,
        justifyContent:'center',
        alignItems: 'center',
        flex:1
      }}>
        {children}
        <Button color='white' onPress={onDismiss} label={labelButton} width={WIDTH} marginHorizontal={0}/>
      </View>
    </BasicModalBelowWrapper>);
};


